<template>
  <span class="flex flex-row items-center justify-center gap-1 text-base">
    <span class="w-full">
      <span
        class="font-medium text-gray-700"
        :class="{
          'text-sm': size === 'md',
          'text-xs': size === 'sm',
          'text-base': size === 'lg',
        }"
        data-el="form-label-label"
        >{{ label }}{{ label ? ':' : '' }}</span
      >
      <sup class="ml-1 text-xs text-red-500" v-if="label && required">*</sup>
    </span>
    <span v-if="hasNotes">
      <Info :value="notes">
        <template>
          <slot name="notes" />
        </template>
      </Info>
    </span>
  </span>
</template>
<script lang="ts" setup>
import { computed, defineAsyncComponent, useSlots } from 'vue';
import type { FormSize } from '../../lib/services/types';
const Info = defineAsyncComponent(
  () => import('../../components/form/Info.vue'),
);

const props = withDefaults(
  defineProps<{
    label?: string;
    required?: boolean;
    notes?: string;
    size?: FormSize;
  }>(),
  { size: 'md', label: undefined, notes: undefined },
);
const slots = useSlots();
const hasNotes = computed(() => !!slots.notes || props.notes);
</script>
